import type React from "react";
import {Button, CircularProgress, Stack, Typography} from "@mui/material";
import {COLORS} from "~/style/colors-ts";
import {useWithdrawChainCreditRequestMutation} from "~/pages/supplier-360/tabs/SupplierValueChain/hooks/useChainCreditMutations";
import type {ChainCreditRequest} from "~/pages/supplier-360/tabs/SupplierValueChain/valueChainCreditTypes";
import {formatCreditDate} from "~/pages/supplier-360/tabs/SupplierValueChain/chainCredits";
import CalendarIcon from "~/icons/svg/CalendarIcon.svg?react";
import {IconWrapper} from "~/components/IconWrapper/IconWrapper";

/** One pending credit request with its Withdraw action — shown on the locked panel and in Manage credits. */
export const ChainPendingRequest: React.FC<{request: ChainCreditRequest}> = ({request}) => {
    const withdraw = useWithdrawChainCreditRequestMutation();
    const to = request.approver ? ` to ${request.approver}` : '';

    return (
        <Stack
            gap={1}
            sx={{p: 2, borderRadius: 1, border: '1px solid', borderColor: COLORS.warning[500], backgroundColor: COLORS.warning[100]}}
        >
            <Stack direction="row" alignItems="center" gap={1}>
                <IconWrapper color="warning" bg={false}>
                    <CalendarIcon />
                </IconWrapper>
                <Typography variant="caption" fontWeight={600} sx={{height: 16, color: 'warning.500'}}>{request.requested_amount} credits pending approval</Typography>
            </Stack>

            <Stack flexGrow={1}>
                <Typography variant="caption" color="text.secondary">
                    {`Sent ${formatCreditDate(request.requested_at)}${to}`}
                </Typography>
            </Stack>
            <Button
                variant="outlined"
                size="small"
                disabled={withdraw.isPending}
                endIcon={withdraw.isPending ? <CircularProgress size={14} color="inherit"/> : undefined}
                onClick={() => withdraw.mutate({request})}
                sx={{textTransform: 'none', backgroundColor: 'white !important', alignSelf: 'flex-start', mt: 0.5}}
            >
                Withdraw request
            </Button>
        </Stack>
    );
};
